/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import Step from "@material-ui/core/Step";

const StyledStep = styled(({ ...props }) => <Step {...props} />)`
  ${({ theme }) => `
  `}
`;

export { StyledStep };
